module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bmvform"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h1', [_vm._v("Contact Us")]), _vm._v(" "), _c('form', {
    staticClass: "contact_form",
    attrs: {
      "action": "https://formspree.io/info@bemorevisible.com",
      "method": "POST"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    class: {
      notempty: _vm.email != ''
    },
    attrs: {
      "type": "email",
      "name": "_replyto",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Email")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('button', {
    staticClass: "submit"
  }, [_c('div', {
    staticClass: "submit--text"
  }, [_vm._v("Submit")]), _c('div', {
    staticClass: "working"
  }, [_c('icon', {
    staticClass: "fa fa-spinner fa-2x",
    attrs: {
      "name": "spinner",
      "scale": "2"
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "successful"
  }, [_c('p', [_c('b', [_vm._v("Thank you for contacting Visible.")]), _c('br'), _vm._v("We'll be in touch soon.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "failure"
  }, [_c('p', [_c('b', [_vm._v("ERROR: Oops! This is embarassing")]), _c('br'), _vm._v("Something went wrong with your submission.  Please email us at "), _c('a', {
    attrs: {
      "href": "mailto:info@bemorevisible.com"
    }
  }, [_vm._v("info@bemorevisible.com")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "name",
      "required": ""
    }
  }), _vm._v(" "), _c('label', [_vm._v("Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field"
  }, [_c('textarea', {
    attrs: {
      "name": "message",
      "required": ""
    }
  }), _vm._v(" "), _c('label', [_vm._v("Message")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2169dd40!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form.vue
// module id = 107
// module chunks = 2